import { memo, useEffect, useState } from "react";
import VehicleDropdown from "ui/components/Dropdown/VehicleDropdown/VehicleDropdown";
import { DatePicker } from "ui/components/DatePicker";
import { useHandleDateChange, useHandleDropdownChange, useHandleNumberFieldChange } from "services/forms/hooks";
import { getFleetVehicleAPI } from "services/api/fleet/vehicles/api";
import TireSetKmField from "ui/modules/fleet/tires/pages/components/TireSetKmField/TireSetKmField";
import { Errors } from "services/forms/validation/types";
import { MountFormValues } from "../types";

interface MountStep1Props {
  formValues: MountFormValues;
  setFormValues: React.Dispatch<React.SetStateAction<MountFormValues>>;
  errors: Errors;
}

const MountStep1: React.FC<MountStep1Props> = ({ formValues, setFormValues, errors }) => {
  const handleDateChange = useHandleDateChange(setFormValues, formValues);
  const handleDropdownChange = useHandleDropdownChange(setFormValues, formValues);
  const handleNumberFieldChange = useHandleNumberFieldChange(setFormValues, formValues);
  const [vehicleKm, setVehicleKm] = useState<number | null>(null);

  useEffect(() => {
    setVehicleKm(null);
    if (formValues.targetVehicleId) fetchVehicleKm(formValues.targetVehicleId);
  }, [formValues.targetVehicleId]);

  const fetchVehicleKm = async (vehicleId: string) => {
    try {
      const vehicle = await getFleetVehicleAPI(vehicleId);
      setVehicleKm(vehicle.kmTraveled ?? null);
    } catch { /* */ }
  };

  return (
    <div className="flex items-center justify-center px-4 min-h-[70vh] 2xl:min-h-[1000px]">
      <div className="w-full max-w-2xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1 mb-2">Odaberite vozilo</h1>
        <p className="text-center text-md text-slate-500 mb-8">Na koje vozilo želite montirati odabrani set guma?</p>

        <div className="border bg-white border-slate-200">
          <div className="border-b border-slate-200 py-6 px-4">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">Odredište</h3>
              <p className="text-xs text-slate-500">Na koje vozilo se set montira</p>
            </div>
            <div>
              <div>
                <VehicleDropdown
                  name="targetVehicleId"
                  label="Vozilo"
                  placeholder="Pretražite vozila..."
                  value={formValues.targetVehicleId}
                  onChange={handleDropdownChange}
                  width="full"
                  error={errors.targetVehicleId}
                  required
                />
              </div>
            </div>
          </div>
          <div className="py-6 px-4">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">Datum i kilometraža</h3>
              <p className="text-xs text-slate-500">Kada su gume montirane i stanje brojača vozila</p>
            </div>
            <TireSetKmField
              value={formValues.kmTraveled}
              onChange={handleNumberFieldChange}
              error={errors.kmTraveled}
              vehicleKm={vehicleKm}
            >
              <div>
                <DatePicker
                  name="transferDate"
                  label="Datum montaže"
                  placeholder="Odaberite datum..."
                  onChange={handleDateChange}
                  error={errors.transferDate}
                  value={formValues.transferDate}
                  width="full"
                  required
                />
              </div>
            </TireSetKmField>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(MountStep1);
